import { createFileRoute } from '@tanstack/react-router';
import { GradeSubmissionScreen } from '@/quiz-submission/GradeSubmissionScreen';

/**
 * The member mount of the grade screen. On a congregation or custom study group
 * the group's pending table has no row actions, as in legacy, so this is the
 * only way to grade there. The form lives in `@/quiz-submission/`, shared with
 * the group mount.
 *
 * `$memberId` is decorative: authorization is on the grading, so any member URL
 * renders the grading it names.
 */
export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/quizzes/grade/$submissionId',
)({
  component: MemberQuizSubmissionGradeScreen,
});

function MemberQuizSubmissionGradeScreen() {
  const { submissionId } = Route.useParams();
  return (
    <GradeSubmissionScreen submissionId={Number.parseInt(submissionId, 10)} />
  );
}
